export default {  

    end: "Tu perfil de Farmer 4.0",

    profile: "tu perfil",

    restart: "Reiniciar el cuestionario",

    submit: "Enviar",

    print: "Descarga tu perfil en PDF",

    data: "Tus datos",

    progress: "Progreso",

    confirm: {

        restart: '¿Está seguro de que quiere PERDER TODOS SUS DATOS y reiniciar la prueba'

    },

    steps: {

        "0-1": "EVALUACIÓN DEL NIVEL EDUCATIVO",

        "0-2": "EXPERIENCIA EMPRESARIAL EN AGRICULTURA",

        "1-1": "IDENTIFICACIÓN DE LAS EXPERIENCIAS ANTERIORES EN AGRICULTURA",

        "1-2": "IDENTIFICACIÓN DE LAS EXPERIENCIAS ANTERIORES EN AGRICULTURA",

        "1-3": "IDENTIFICACIÓN DE LAS EXPERIENCIAS ANTERIORES EN AGRICULTURA",

        "1-4": "IDENTIFICACIÓN DE LAS EXPERIENCIAS ANTERIORES EN AGRICULTURA",

        "2": "PROPENSIÓN AL EMPRENDIMIENTO",

        "3-1": "HABILIDADES BLANDAS PARA SER UN EMPRESARIO DE ÉXITO - CREATIVIDAD",

        "3-2": "HABILIDADES SOCIALES PARA SER UN EMPRESARIO DE ÉXITO - COMUNICACIÓN PARTE 1",

        "3-3": "HABILIDADES SOCIALES PARA SER UN EMPRESARIO DE ÉXITO - COMUNICACIÓN PARTE 2",

        "3-4": "HABILIDADES SOCIALES PARA SER UN EMPRESARIO DE ÉXITO - COMUNICACIÓN PARTE 3",

        "3-5": "HABILIDADES SOCIALES PARA SER UN EMPRESARIO DE ÉXITO - COMUNICACIÓN PARTE 4",

        "4-1": "COMPETENCIAS TIC - COMPETENCIAS CLAVE",

        "4-2-1": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "4-2-2": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "4-2-3": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "4-2-4": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "4-2-5": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "4-2-6": "COMPETENCIAS DE LAS TIC DEL AGRICULTOR 4.0",

        "5-1": "OTRAS COMPETENCIAS PROFESIONALES PARA SER AGRICULTOR 4.0",

        "5-2": "OTRAS COMPETENCIAS PROFESIONALES PARA SER AGRICULTOR 4.0",

        "5-3": "OTRAS COMPETENCIAS PROFESIONALES PARA SER AGRICULTOR 4.0",

    },

    questions: {

        "0-1-1" : "Seleccione su nivel educativo", 

        "0-2-1" : "¿Cuál es el campo en el que usted es/le gustaría ser un empresario en la agricultura? ",

        "1-1-1" : "¿Tiene alguna experiencia previa en agricultura como empresario?",

        "1-2-1" : "¿Tienes algún otro tipo de experiencia en el campo de la agricultura en el que desees convertirte en empresario?",

        "1-3-1" : "¿Qué otras experiencias previas tiene en el ámbito agrícola?",

        "1-4-1" : "¿Cuánto tiempo estuvo en este puesto?",

        "1-4-2" : "¿Cuánto tiempo hace que adquirió esta experiencia?",

        "2-1" : "Estoy dispuesto a trabajar regularmente 50 horas o más a la semana",

        "2-2" : "Mi familia apoyará que me dedique a los negocios Mi familia apoyará mi deseo de emprender un negocio",

        "2-3" : "Estoy dispuesto a aceptar riesgos financieros y laborales cuando sea necesario",

        "2-4" : "No necesito todos los beneficios adicionales que ofrece un empleo regular (por ejemplo, cotizaciones a la pensión, vacaciones pagadas)",

        "2-5" : "Estoy dispuesto a asumir toda la responsabilidad de los éxitos y/o fracasos de mi empresa",

        "2-6" : "Tendré más éxito económico si tengo mi propia empresa. La posibilidad de éxito económico es mayor si tengo mi propio negocio",

        "2-7" : "Me siento muy orgulloso cuando termino un proyecto con éxito",

        "2-8" : "Tengo un nivel de energía elevado que se puede mantener durante mucho tiempo",

        "2-9" : "Me gusta tener el control sobre mis propias tareas y decisiones que afectan a mi trabajo",

        "2-10" : "Creo que soy responsable de mis propios éxitos y fracasos",

        "2-11" : "Tengo un fuerte deseo de obtener resultados positivos aunque me cueste un gran esfuerzo adicional",

        "2-12" : "Tengo un buen conocimiento de la gestión de una empresa",

        "2-13" : "Puedo actuar en situaciones en las que las cosas cambian rápidamente ",

        "2-14" : "Uno de mis padres, o ambos, fueron empresarios",

        "2-15" : "Creo que tengo mejores capacidades y habilidades que otras personas con las que he trabajado",

        "2-16" : "La gente confía en mí y me considera honesto y fiable",

        "2-17" : "Siempre intento completar todos los proyectos que empiezo, sin importar los obstáculos y las dificultades que pueda encontrar",

        "2-18" : "Estoy dispuesto a hacer algo aunque los demás se rían o me critiquen por hacerlo",

        "2-19" : "Puedo tomar decisiones rápidamente",

        "2-20" : "Tengo una buena red de amigos, profesionales y conocidos de negocios",

        "3-1-1" : "Cuando me enfrento a un problema en el trabajo, me gusta encontrar varias soluciones alternativas posibles",

        "3-1-2": "Si recibo una nueva tarea, prefiero seguir las instrucciones cuidadosamente para evitar problemas",

        "3-1-3": "Cuando veo algo extraño e inusual, prefiero no involucrarme para evitar inconvenientes ", 

        "3-1-4": "En una discusión, me gusta escuchar las ideas de los demás, aunque no tenga/comparta las mismas ideas",

        "3-1-5": "Cuando las cosas no están claras, pido explicaciones para entender mejor",

        "3-1-6": "Cuando tengo que hacer un trabajo repetitivo, suelo buscar diferentes maneras de terminar la tarea (ya sea para encontrar un método más rápido, un nuevo método o para asegurarme de que no es inútil) para hacerlo más rápido, para hacerlo de una nueva manera, o incluso para darme cuenta de si no debo hacerlo porque es inútil)",

        "3-1-7": "Prefiero razonar con \"lógica y racionalidad\", dejando de lado los argumentos emocionales e impulsivos.",

        "3-1-8": "Me encantan los nuevos retos: me motivan a dar lo mejor de mí.",

        "3-1-9": "Me gusta jugar con las ideas",

        "3-1-10": "Estoy de acuerdo con la afirmación \"copiar es útil porque permite innovar\"",

        "3-1-11": "En situaciones complejas, acudo a expertos o a quienes veo como expertos",

        "3-1-12": "Para convencer a los demás de que mi idea es correcta, estoy dispuesto a luchar, explicar y demostrar el valor de mi idea",

        "3-1-13": "La anarquía, en pequeñas dosis, es una fuerte herramienta de innovación ",

        "3-1-14": "Empiezo las tareas sin terminarlas del todo ",

        "3-1-15": "Es imposible ser creativo en el trabajo de oficina",

        "3-1-16": "Si cambio de trabajo, prefiero uno con tareas rutinarias o en el que sepa qué tareas tengo que hacer",

        "3-1-17": "trabajo, intento no pensar demasiado en ello. Utilizo mi intuición para encontrar una solución",

        "3-1-18": "No creo que los aspectos administrativos y contables de una tarea sean importantes y centraría esa atención en las prioridades estratégicas",

        "3-1-19": "Prefiero la fase creativa de una tarea porque puedo cooperar con otros para producir nuevas ideas",

        "3-1-20": "Prefiero las artes/humanidades a las ciencias naturales/financieras",

        "3-1-21": "Estoy abierto al hecho de que puede haber formas alternativas de alcanzar el resultado deseado",

        "3-1-22": "Ser innovador en el trabajo es una limitación. Es mejor estar de acuerdo con el resto del grupo",

        "3-1-23": "Cuando elijo un restaurante o un bar, prefiero los que ya conozco porque sé lo que voy a conseguir.",

        "3-1-24": "Incluso cuando hay situaciones graves y críticas, me gusta pensar que hay una solución posible. Sólo hay que buscarla. No ayuda perder la esperanza",

        "3-1-25": "Conozco y aplico métodos y técnicas para desarrollar la creatividad en el trabajo",

        "3-2-1": "Puedo impresionar a la persona que habla conmigo ",

        "3-2-2": "El que más habla es más fuerte en la discusión ",

        "3-2-3": "Sé cómo transmitir mis ideas",

        "3-2-4": "Me siento cómodo en las discusiones",

        "3-2-5": "Me siento cómodo en las discusiones",

        "3-2-6": "No tengo miedo de avergonzar a la otra persona en la discusión",

        "3-2-7": "No tengo miedo de nadie",

        "3-2-8": "Me gustan las contradicciones ",

        "3-2-9": "Es necesario poder enfadarse",

        "3-2-10": "En una discusión quiero ganar",

        "3-3-1": "Suelo defender mis ideas con firmeza",

        "3-3-2": "Rara vez me confundo",

        "3-3-3": "Puedo defender una idea con la que no estoy de acuerdo",

        "3-3-4": "Trato de entender lo que la otra persona está tratando de lograr/la intención de otra persona",

        "3-3-5": "Me siento cómodo pidiendo una explicación de una idea o me siento cómodo declarando que no he entendido una idea ",

        "3-3-6": "Soy capaz de atraer la atención de los demás y mantener su interés ",

        "3-3-7": "Sé que tanto yo como mi interlocutor podemos cometer errores",

        "3-3-8": "Defiendo firmemente mis ideas",

        "3-3-9": "No busco los conflictos, pero no les tengo miedo",

        "3-3-10": "Puedo cambiar de opinión sin sentirme manipulado",

        "3-4-1": "A menudo sueño despierto ",

        "3-4-2": "A menudo no me atrevo a hablar aunque me gustaría hacerlo",

        "3-4-3": "Prefiero no hablar de mis ideas con ciertas personas",

        "3-4-4": "A veces olvido lo que iba a decir cuando hablo",

        "3-4-5": "No me gusta involucrarme en conflictos y trato de evitarlos",

        "3-4-6": "A menudo me mantengo al margen de la discusión porque no sé cómo defender mis ideas",

        "3-4-7": "Me siento mejor sin participar en el debate en lugar de unirme a la lucha",

        "3-4-8": "Me gustaría poder ser más asertivo cuando (expresar mis necesidades con más fuerza)",

        "3-4-9": "Incluso cuando me preguntan, me resulta difícil expresarme de forma clara",

        "3-4-10": "Rara vez hablo primero",

        "3-5-1": "Evito los conflictos porque no conducen a nada",

        "3-5-2": "Me gusta utilizar argumentos conflictivos y/o inesperados",

        "3-5-3": "Es necesario poder desanimar al que habla",

        "3-5-4": "Dejo hablar a los demás para averiguar información sobre ellos",

        "3-5-5": "Se me da bien defender un punto de vista con el que no estoy de acuerdo",

        "3-5-6": "Se puede persuadir a la gente más fácilmente cuando se la halaga",

        "3-5-7": "Hablar primero es un riesgo innecesario",

        "3-5-8": "Provocar una discusión entre los demás participantes es una buena forma de ganar el control de una situación",

        "3-5-9": "Sé ocultar mis ideas cuando creo que los demás no están de acuerdo con ellas",

        "3-5-10": "To cause an argument between the other people in the discussion is a good way to gain control of a situation when I think others don't agree with them",

        "4-1-1": "Utilizar un programa de tratamiento de textos, por ejemplo, Word, Pages, Writer, Google Docs, etc.",

        "4-1-2": "Utilizar un programa de hoja de cálculo, por ejemplo, Excel, Numbers, Calc, Google Sheets, etc",

        "4-1-3": "Utilizar Internet para buscar información",

        "4-1-4": "Utilizar herramientas de comunicación y redes sociales, por ejemplo, correo electrónico, Facebook, LinkedIN",

        "4-2-1": "¿Puede trabajar con CAD?",

        "4-2-2": "¿Puede trabajar con CAE?",

        "4-2-3": "¿Puede trabajar con CAM?",

        "4-2-4": "¿Puede trabajar en RE?",

        "4-2-5": "¿Puede trabajar en el campo de la fabricación aditiva?",

        "4-2-6": "¿Puede utilizar las redes sociales (por ejemplo, Facebook, Instagram, Pinterest...) o un sitio web para presentarse y presentar su granja/actividades o vender sus productos?",

        "5-1": "¿Sabes cómo crear una red de \"agricultores digitales\" siguiendo las normas del GDPR y cómo adoptar un modelo de gobernanza adecuado de tu granja basado en el concepto de FABLAB, introduciendo tecnologías 4.0?",

        "5-2": "¿Eres experto en la internacionalización de tu negocio?",

        "5-3": "¿Conoce la \"agricultura sostenible\" y la pone en  práctica?",

    },

    answers: {

        "yes": "Sì",

        "no": "No",

        "s_agree" : "Muy de acuerdo",

        "agree": "De acuerdo",

        "sw_agree": "Algo de acuerdo",

        "disagree" : "En desacuerdo",

        "s_disagree": "Muy en desacuerdo",

        "never": "Nunca",

        "rarely": "Rara vez",

        "often": "A menudo",

        "always": "Siempre",

        "true": "Verdadero",

        "false": "Falso",

        "insecure": "Me siento inseguro y necesito ayuda para utilizar este tipo de herramientas",

        "confident": "Me siento bastante seguro y suelo encontrar las soluciones por mí mismo cuando utilizo esta herramienta",

        "indipendent": "Trabajo con independencia y confianza y soy capaz de enseñar a otros a utilizar esta herramienta",

        "dontknow": "No sé",   

        "0-1-1-0": "Nada",

        "0-1-1-1": "Educación infantil",

        "0-1-1-2": "Educación primaria",

        "0-1-1-3": "Educación secundaria obligatoria",

        "0-1-1-4": "Educación superior",

        "0-1-1-5": "Técnico superior",

        "0-1-1-6": "Grado",

        "0-1-1-7": "Master",

        "0-1-1-8": "Doctor",

        "0-2-1-11": "Cultivo de cereales (excepto arroz), leguminosas y semillas oleaginosas", 

        "0-2-1-12": "Cultivo de arroz", 

        "0-2-1-13": "Cultivo de hortalizas, raíces y tubérculos",

        "0-2-1-14": "Cultivo de caña de azúcar", 

        "0-2-1-15": "Cultivo de tabaco", 

        "0-2-1-16": "Cultivo de plantas para fibras textiles", 

        "0-2-1-17": "Otros cultivos no perennes", 

        "0-2-1-21": "Cultivo de la vid", 

        "0-2-1-22": "Cultivo de frutos tropicales y subtropicales", 

        "0-2-1-23": "Cultivo de cítricos", 

        "0-2-1-24": "Cultivo de frutos con hueso y pepitas", 

        "0-2-1-25": "Cultivo de otros árboles y arbustos frutales y frutos secos", 

        "0-2-1-26": "Cultivo de frutos oleaginosos", 

        "0-2-1-27": "Cultivo de plantas para bebidas", 

        "0-2-1-28": "Cultivo de especias, plantas aromáticas, medicinales y farmacéuticas", 

        "0-2-1-29": "Otros cultivos perennes",  

        "0-2-1-30": "Propagación de plantas", 

        "0-2-1-41": "Explotación de ganado bovino para la producción de leche", 

        "0-2-1-42": "Explotación de otro ganado bovino y búfalos", 

        "0-2-1-43": "Explotación de caballos y otros equinos", 

        "0-2-1-44": "Explotación de camellos y otros camélidos", 

        "0-2-1-45": "Explotación de ganado ovino y caprino", 

        "0-2-1-46": "Explotación de ganado porcino", 

        "0-2-1-47": "Avicultura", 

        "0-2-1-48": "Otras explotaciones de ganado", 

        "0-2-1-50": "Producción agrícola combinada con la producción ganadera", 

        "0-2-1-61": "Actividades de apoyo a la agricultura", 

        "0-2-1-62": "Actividades de apoyo a la ganadería", 

        "0-2-1-63": "Actividades de preparación posterior a la cosecha ", 

        "0-2-1-64": "Tratamiento de semillas para reproducción", 

        "0-2-1-70": "Caza, captura de animales y servicios relacionados con las mismas", 

        "1-3-1-1" : "experiencia educativa",

        "1-3-1-2" : "trabajo voluntario",

        "1-3-1-3" : "otras experiencias",

        "1-4-1-1" : "Menos de 3 años",

        "1-4-1-2" : "Más de 3 años",

    },

    results: {

        "1-1": "Incluso si ya tiene alguna experiencia previa en agricultura como empresario, nuestra plataforma FARMER 4.0 podría ayudarle a profundizar en algunos conceptos importantes para su éxito como agricultor 4.0. De todos modos, ¿cómo es tu predisposición a emprender y qué hay de tus habilidades blandas para emprender? ",

        "1-2": "Dado que no tienes experiencia como empresario en la agricultura, es importante entender en primer lugar tu propensión a emprender y si necesitas adquirir algunas habilidades técnicas o blandas para tener éxito en el campo en el que deseas trabajar. A este respecto podemos decir que ",

        "1-4": {

            score: {

                "0-1": "Aunque haya realizado otras experiencias (distintas de las profesionales) en el ámbito de la agricultura, este tipo de experiencias puede no ser lo suficientemente largo (en términos de tiempo) o reciente, por lo que es importante entender en primer lugar su propensión real a emprender y si posee el nivel adecuado de habilidades necesarias para tener éxito como agricultor 4.0. A este respecto podemos decir que",

                "2" : "Aunque haya realizado otras experiencias recientes e importantes (además de las profesionales) en la agricultura, no tiene ninguna experiencia como empresario, por lo que es importante comprender en primer lugar su verdadera propensión a la iniciativa empresarial y si posee el nivel adecuado de habilidades necesarias para tener éxito como agricultor 4.0. A este respecto podemos decir que"

            }

        },

        "2": {

            score: {

            "39": "Probablemente debería evitar el espíritu empresarial. Le sugerimos una entrevista con un asesor para verificar sus verdaderas expectativas",

            "59": "El autoempleo/la actividad empresarial puede no ser una carrera adecuada para usted. Le sugerimos una entrevista con un evaluador para verificar sus expectativas reales",

            "79" : "Parece que tiene capacidades satisfactorias para ser empresario",

            "100": "Parece que tiene capacidades sobresalientes para ser empresario",

            }

        },

        "3-1": {

            score: {

            "44": "La creatividad es para usted una irritación. No ve ninguna oportunidad en la creatividad. Evita las situaciones en las que tiene que ser creativo. Prefieres trabajar de forma estructurada y lógica. No te gustan las situaciones que cambian mucho ni el proceso de toma de decisiones. Si quieres tener éxito en la agricultura 4.0, te sugerimos que mejores tu creatividad (por ejemplo, siguiendo un curso sobre esta habilidad blanda o pidiendo ayuda a un formador/mentor)",

            "64": "La creatividad para usted es una obligación. Prefieres un trabajo en el que sepas qué tareas hacer y en el que rara vez tengas que ser creativo. Sin embargo, cuando la situación lo requiere, eres capaz de encontrar soluciones alternativas. Puedes desarrollar tu creatividad siendo más flexible. Si quieres tener éxito en la agricultura 4.0, te sugerimos que mejores tu creatividad (por ejemplo, siguiendo un curso sobre esta habilidad blanda o pidiendo ayuda a un formador/mentor).",

            "84" : " La creatividad para usted es necesaria. La creatividad no es un problema para usted, sino que a menudo es necesaria. Hacer las cosas de forma nueva es un valor y a veces una necesidad. Crees que a veces hay que encontrar la solución en lo \"no conocido\". Eres capaz de encontrar un equilibrio entre los procedimientos fijos y estar abierto a las alternativas. Eres consciente de que debes ser minucioso cuando realizas un trabajo rutinario. Esto es bueno para quien quiera tener éxito en la agricultura 4.0",

            "100": "La creatividad para ti es un placer. Tienes muchas ideas y siempre estás dispuesto a encontrar nueva inspiración, nuevas ideas y nuevos proyectos. Necesitas estar en un entorno que estimule tu creatividad y fantasía, de lo contrario te aburres y no te sientes suficientemente valorado. Pero, por favor, presta atención: la intuición es necesaria, pero no suficiente. Esto es bueno para quien quiera tener éxito en la agricultura 4.0"

            }

        },

        "3-2": {

            score: {

            "2": "Eres poco decidido (a corto plazo) y ejerces una falta de constancia para conseguir tus objetivos (a medio y largo plazo).Esto no es bueno para quien quiere trabajar como empresario de éxito en la agricultura: de hecho, una de las características más importantes de los empresarios es la determinación. Este rasgo está estrechamente relacionado con la confianza en uno mismo. Cuanto más creas en ti mismo, más probable será que sigas luchando por el éxito cuando te enfrentes a tremendos obstáculos. Necesitas determinación para superar los problemas que acechan a toda nueva empresa.Ten en cuenta que debes mejorar tu capacidad para ser determinado y constante en la consecución de tus objetivos (es decir, seguir un curso sobre estas habilidades blandas o pedir ayuda a un formador/mentor).",

            "5": "No siempre tiene determinación (a corto plazo) y, en ocasiones, puede no ser constante al intentar alcanzar sus objetivos (a medio y largo plazo). Esto no es bueno para quien quiere trabajar como empresario de éxito en la agricultura: de hecho, una de las características más importantes de los empresarios es la determinación. Este rasgo está estrechamente relacionado con la confianza en uno mismo. Cuanto más creas en ti mismo, más probable será que sigas luchando por el éxito cuando te enfrentes a tremendos obstáculos. Necesitas determinación para superar los problemas que acechan a toda nueva empresa. Ten en cuenta que debes mejorar tu capacidad para ser determinado y constante en la consecución de tus objetivos (es decir, seguir un curso sobre estas habilidades blandas o pedir ayuda a un formador/mentor).",

            "6" : "Eres muy decidido (a corto plazo) y muy constante a la hora de conseguir tus objetivos (a medio y largo plazo). Esto es excelente para un empresario del sector agrícola.",

            "9": "Tiene una ligera tendencia a desvalorizar la acción de otras personas y a mostrar sentimientos negativos hacia la persona que actúa en lugar de la acción en sí. Esto no es bueno para quien quiere trabajar como empresario de éxito en la agricultura. Por favor, ten en cuenta que debes mejorar tu capacidad para colaborar más con los demás (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor).",

            "12": "En general, usted muestra una tendencia a desvalorizar la acción de otras personas y a mostrar sentimientos negativos hacia la persona que actúa en lugar de la acción en sí. Esto no es bueno para quien quiere trabajar como empresario de éxito en la agricultura. Por favor, ten en cuenta que debes mejorar tu capacidad de colaboración con los demás (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor)",

            }

        },

        "3-3": {

            score: {

            "2": "En general, muestra una fuerte tendencia a no sentirse responsable de sus acciones: los empresarios de éxito tienen un locus de control interno o sentido de responsabilidad interior por el resultado de una empresa. Para ser un emprendedor, debe tener un fuerte sentido de ser un \"vencedor\" que es responsable de sus acciones. Sin embargo, si a menudo te consideras una \"víctima\" y culpas a otras personas, a la mala suerte o a las circunstancias difíciles de tus fracasos, puede que el emprendimiento no sea la carrera adecuada para ti. Te sugerimos que trabajes en este asunto (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor)",

            "5": "IEn general, muestra una tendencia moderada a sentirse responsable de sus acciones: los empresarios de éxito tienen un locus de control interno o sentido de responsabilidad interior por el resultado de una empresa. Para ser un emprendedor, debe tener un fuerte sentido de ser un \"vencedor\" que es responsable de sus acciones. Sin embargo, si a menudo te consideras una \"víctima\" y culpas a otras personas, a la mala suerte o a las circunstancias difíciles de tus fracasos, puede que el emprendimiento no sea el camino profesional adecuado para ti. Te sugerimos que trabajes en este asunto (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor).",

            "6" : "Muestras una tendencia suficiente a sentirte responsable y, por tanto, una propensión igualmente suficiente a comprometerte con la consecución de los objetivos: los emprendedores de éxito tienen un locus de control interno o sentido de responsabilidad interior por el resultado de una empresa. Para ser empresario, debe tener un fuerte sentido de ser un \"triunfador\" que es responsable de sus acciones. Sin embargo, si a menudo te consideras una \"víctima\" y culpas a otras personas, a la mala suerte o a las circunstancias difíciles de tus fracasos, puede que el emprendimiento no sea el camino profesional adecuado para ti. Te invitamos a mejorar tu asertividad (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor).",

            "9": "Muestras una buena tendencia a sentirte responsable y, por lo tanto, una propensión igualmente buena a comprometerte para lograr los objetivos. Esto es bueno para quien quiere ser un empresario de éxito en la agricultura",  

            "12": "Muestras tu excelente tendencia a sentirte responsable y, por tanto, una propensión igualmente excelente a comprometerte para conseguir los objetivos. Esto es excelente para quien quiere ser un empresario de éxito en la agricultura",  

            }

        },

        "3-4": {

            score: {

            "2": "Puede tener una tendencia a mantener todo bajo control (falta de capacidad selectiva) y puede confundir los objetivos a corto plazo con los objetivos a largo plazo, lo que puede dar lugar a estar abrumado por los plazos. Esta situación debe mejorarse (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor) porque los empresarios son personas que asumen riesgos. Arriesgan su carrera, su tiempo y su dinero para que sus negocios tengan éxito. Para tener éxito como autónomo, debes sentirte cómodo asumiendo riesgos razonables",

            "5": "Es posible que le resulte difícil priorizar los objetivos y que no siempre sea capaz de distinguir entre asuntos muy urgentes y no urgentes. Esto puede llevar a situaciones muy estresantes. Los empresarios son personas que asumen riesgos. Arriesgan su carrera, su tiempo y su dinero para que sus negocios sean un éxito. Para tener éxito en el trabajo por cuenta propia, hay que sentirse cómodo asumiendo riesgos razonables. Hay que mejorar esta situación (es decir, seguir un curso sobre estas habilidades blandas o pedir ayuda a un formador/mentor).",

            "6" : "Tiene una alta capacidad para priorizar objetivos y puede distinguir entre asuntos muy urgentes y no urgentes, como se le exige a un empresario",

            "9": "Tiene dificultades para completar sus tareas diarias y alcanzar sus objetivos. Por cierto, los empresarios tienen una fuerte necesidad de logro. Se esfuerzan por sobresalir y alcanzar objetivos bastante elevados. Deberías estar dispuesto a fijarte objetivos elevados y disfrutar esforzándote por alcanzarlos. Teniendo esto en cuenta, tienes que mejorar tu capacidad (es decir, seguir un curso sobre estas habilidades blandas o pedir ayuda a un formador/mentor).",

            "12": "Tiene dificultades para realizar sus tareas diarias y alcanzar sus objetivos. Sin embargo, esta situación puede mejorarse (por ejemplo, siguiendo un curso sobre estas habilidades blandas o pidiendo ayuda a un formador/mentor) porque los empresarios son personas que asumen riesgos. Arriesgan su carrera, su tiempo y su dinero para que sus negocios tengan éxito. Para tener éxito como autónomo, debes sentirte cómodo asumiendo riesgos razonables",

            }

        },

        "3-5": {

            score: {

            "2": "Tiene una gran capacidad para \"hacerlo usted mismo\", sin ayuda de otras personas y para actuar con su propio liderazgo/iniciativa/impulso. Pero a veces es necesario consultar a otros profesionales para obtener consejos, información y referencias si quiere alcanzar el éxito. Por ello, le sugerimos que mejore su capacidad para alcanzar sus objetivos profesionales implicando a otros interlocutores",

            "5": "YTienes una capacidad media para trabajar por tu propia iniciativa/impulso/capacidad sin pedir ayuda a los demás. Pero a veces esto podría no ser suficiente. Por ello, le sugerimos que mejore su capacidad para alcanzar sus objetivos profesionales implicando a otros interlocutores",

            "6" : "Eres muy capaz de trabajar por tu propia iniciativa/capacidad/impulso pero también sabes cuándo aceptar la ayuda de otras personas y esto es excelente para alguien como tú que quiere alcanzar objetivos profesionales involucrando a otros interlocutores.",

            "9": "Aunque tienes una capacidad media para asignar tareas, a veces dependes demasiado de la ayuda de los demás y de mucha información para apoyar tu decisión. Por lo tanto, le sugerimos que mejore su capacidad para alcanzar sus objetivos profesionales implicando a otros interlocutores sin llegar a su manipulación.",

            "12": "WAunque eres muy capaz de asignar tareas, tiendes a pedir demasiada ayuda y a buscar demasiada información para apoyar tus decisiones y esto podría. Por lo tanto, le sugerimos que mejore su capacidad para alcanzar sus objetivos profesionales implicando a otros interlocutores sin llegar a su manipulación",

            }

        },

        "4-1": {

            score: {

            "5": "Si quiere ser capaz de utilizar las herramientas de FARMER 4.0, tiene que ampliar/ampliar/desarrollar sus conocimientos generales de TIC tras un curso (al menos de nivel básico)",

            "8": "Si quiere ser capaz de utilizar correctamente las herramientas de FARMER 4.0, podría mejorar sus conocimientos siguiendo un curso (nivel medio)",

            "10" : "Enhorabuena: sus conocimientos generales de las TIC son avanzados y no tendría que tener ningún problema para utilizar las herramientas y los modelos de FARMER 4.0.",

            }

        },

        

        "4-2-1": {

            "Si":"Incluso si ya sabe trabajar con CAD, le invitamos a echar un vistazo al módulo CAD/CAM/CAE/RE en la plataforma FARMER 4.0",

            "No": "Es necesario seguir el módulo CAD en la plataforma FARMER 4.0",

        },

        "4-2-2": {

            "Si": "Incluso si ya puede trabajar con CAE, le invitamos a echar un vistazo al módulo CAD/CAM/CAE/RE en la plataforma FARMER 4.0",

            "no": "Debe seguir el módulo CAE en la plataforma FARMER 4.0",

        },

        "4-2-3": {

            "Si": "Incluso si ya puede trabajar con CAM, le invitamos a echar un vistazo al módulo CAD/CAM/CAE/RE en la plataforma FARMER 4.0",

            "no": "Es necesario seguir el módulo CAM en la plataforma FARMER 4.0",

        },

        "4-2-4": {

            "si": "Incluso si ya puede trabajar en RE, le invitamos a echar un vistazo al módulo CAD/CAM/CAE/RE en la plataforma FARMER 4.0",

            "no": "Es necesario seguir el módulo RE en la plataforma FARMER 4.0",

        },

        "4-2-5": {

            "si": "Incluso si ya puede trabajar en la fabricación aditiva, le invitamos a echar un vistazo al módulo de fabricación aditiva - impresión 3D en la plataforma FARMER 4.0",

            "no": "Debe seguir el módulo de Fabricación Aditiva - Impresión 3D en la plataforma FARMER 4.0",

        },

        "4-2-6": {

            "si": "Incluso si ya puede utilizar las redes sociales (p. ej., Facebook, Instagram, Pinterest...) o un sitio web para presentarse y presentar sus explotaciones/actividades o vender sus productos, le invitamos a echar un vistazo a los módulos \"Redes sociales para la granja global 4.0\" y \"Herramientas y técnicas de comunicación en línea\" de la plataforma FARMER 4.0",

            "no": "Debe seguir los módulos \"Redes sociales para la granja global 4.0\" y \"Herramientas y técnicas de comunicación en línea\" de la plataforma FARMER 4.0",

        },

        "5-1": {

            "yes": "Incluso si ya eres capaz de trabajar con un enfoque fablab y conoces muy bien la digitalización en la agricultura, te invitamos a echar un vistazo al módulo \"Emprendimiento agrícola basado en el enfoque FabLab\" en la plataforma FARMER 4.0",

            "no": "Debes seguir el módulo \"Emprendimiento agrícola basado en el enfoque FabLab\" en la plataforma FARMER 4.0",

        },

        "5-2": {

            "si": "Incluso si ya puede trabajar en un contexto internacional, le invitamos a que eche un vistazo al módulo \"Internacionalización y sostenibilidad de la granja global 4.0\" en la plataforma FARMER 4.0",

            "no": "Es necesario seguir el módulo \"Internacionalización y sostenibilidad de la granja global 4.0\" en la plataforma FARMER 4.0",

        },

        "5-3": {

            "si": "Incluso si trabajas por la sostenibilidad de la agricultura, te invitamos a echar un vistazo al módulo \"Internacionalización y sostenibilidad de la granja global 4.0\" en la plataforma FARMER 4.0",

            "no": "Es necesario seguir el módulo \"Internacionalización y sostenibilidad de la granja global 4.0\" en la plataforma FARMER 4.0"

        }

    }

}

